import {createContext} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import BreadcrumbInterface from "./interfaces/core/BreadcrumbInterface";


const defaultContextValue: any = null;


export const GlobalContext = createContext(defaultContextValue);

const broofa = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}

export const initReducerParams = {
    basket: [],
    favorites: [],
    comparison: [],
    error: null,

    isLoading: false,

    searchHistory: [],

    searchString: '',

    showBackdrop: false, // показываем backdrop

    breadcrumbs: [], // хлебные крошки

    uid: broofa(),
    customer: null,
    manager: null,
    lastExecutionTime: Date.now(),
    showTechInfo: false,
    meta: null // мета параметры страницы
}

export const showBackdrop = {
    error: null
}

interface ReducerAction {
    paramName?: string
    payload: any
    type: ReducerActionType
}

export enum ReducerActionType {
    SET_PARAM = 'SET_PARAM',

    ADD_TO_BASKET = 'ADD_TO_BASKET',
    REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET',
    SET_BASKET = 'SET_BASKET',
    CLEAR_BASKET = 'CLEAR_BASKET',
    UPDATE_BASKET_QUANTITY = 'UPDATE_BASKET_QUANTITY',

    ADD_TO_COMPARISON = 'ADD_TO_COMPARISON',
    REMOVE_FROM_COMPARISON = 'REMOVE_FROM_COMPARISON',
    SET_COMPARISON = 'SET_COMPARISON',

    ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
    REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES',
    SET_FAVORITES = 'SET_FAVORITES',

    SET_CUSTOMER = 'SET_CUSTOMER',
    SET_MANAGER = 'SET_MANAGER',

    LOAD = 'LOAD',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    SET_BREADCRUMBS = 'SET_BREADCRUMBS',
}

export function globalReducer(state: ReducerStateInterface, action: ReducerAction): ReducerStateInterface {
    state.error = null
    switch (action.type) {
        case ReducerActionType.SET_PARAM: {
            if (!action.paramName) {
                throw new Error('Param name not set');
            }

            if (!(action.paramName in state)) {
                throw new Error('Wrong param name ' + action.paramName);
            }
            return {
                ...state,
                [action.paramName]: action.payload,
            };
        }

        case ReducerActionType.ADD_TO_BASKET: {
            let newItem = action.payload;
            let newBasket = [...state.basket];
            let foundIndex = newBasket.findIndex(i => i.product.id === newItem.id);
            if (foundIndex > -1) {
                newBasket[foundIndex] = newItem;
            } else {
                newBasket.push({
                    product: newItem,
                    quantity: 1,
                    createdAt: new Date().toISOString(),
                });
            }
            return {
                ...state,
                basket: newBasket,
            };
        }

        case ReducerActionType.REMOVE_FROM_BASKET: {
            let remove = action.payload;
            let newBasket = state.basket.filter(i => i.product.id !== remove.id);
            return {
                ...state,
                basket: newBasket,
            };
        }

        case ReducerActionType.SET_BASKET: {
            return {
                ...state,
                basket: action.payload,
            };
        }

        case ReducerActionType.CLEAR_BASKET: {
            return {
                ...state,
                basket: [],
            };
        }

        case ReducerActionType.UPDATE_BASKET_QUANTITY: {
            const { productId, quantity } = action.payload;
            const newBasket = state.basket.map(item => {
                if (item.product.id === productId) {
                    return { ...item, quantity };
                }
                return item;
            });
            return {
                ...state,
                basket: newBasket,
            };
        }

        case ReducerActionType.SET_CUSTOMER: {
            return {
                ...state,
                customer: action.payload,
            };
        }

        case ReducerActionType.SET_MANAGER: {
            return {
                ...state,
                manager: action.payload.manager,
                customer: action.payload.customer,
            };
        }

        case ReducerActionType.ADD_TO_COMPARISON: {
            let newItem = action.payload;
            let newComparison = [...state.comparison];
            if (!newComparison.find(i => i.id === newItem.id)) {
                newComparison.push(newItem);
            }
            return {
                ...state,
                comparison: newComparison,
            };
        }

        case ReducerActionType.REMOVE_FROM_COMPARISON: {
            let remove = action.payload;
            let newComparison = state.comparison.filter(i => i.id !== remove.id);
            return {
                ...state,
                comparison: newComparison,
            };
        }

        case ReducerActionType.SET_COMPARISON: {
            let items = action.payload;
            return {
                ...state,
                comparison: items,
            };
        }

        case ReducerActionType.ADD_TO_FAVORITES: {
            let newItem = action.payload;
            let newFavorites = [...state.favorites];
            if (!newFavorites.find(i => i.id === newItem.id)) {
                newFavorites.push(newItem);
            }
            return {
                ...state,
                favorites: newFavorites,
            };
        }

        case ReducerActionType.REMOVE_FROM_FAVORITES: {
            let remove = action.payload;
            let newFavorites = state.favorites.filter(i => i.id !== remove.id);
            return {
                ...state,
                favorites: newFavorites,
            };
        }

        case ReducerActionType.SET_FAVORITES: {
            let items = action.payload;
            return {
                ...state,
                favorites: items,
            };
        }

        case  ReducerActionType.LOAD: {
            return {
                ...state,
                lastExecutionTime: Date.now(),
                isLoading: true,
            };
        }
        case  ReducerActionType.SUCCESS: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case  ReducerActionType.ERROR: {
            return {
                ...state,
                error: typeof action.payload === 'string' ? {message: action.payload} : action.payload,
                isLoading: false,
            };
        }
        case  ReducerActionType.SET_BREADCRUMBS: {
            return {
                ...state,
                breadcrumbs: action.payload
            };
        }

        default:
            return state
    }
}